var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "order-detail-dialog",
      attrs: {
        title: "订单详情",
        visible: _vm.isShow,
        width: "800px",
        center: "",
        "close-on-click-modal": false,
      },
      on: {
        open: _vm.openDialog,
        close: _vm.closeDialog,
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c("el-form", { attrs: { "label-width": "100px" } }, [
        _c(
          "div",
          { staticClass: "order-detail-yto-box" },
          [
            _c(
              "el-row",
              [
                _c("div", { staticClass: "yto-title" }, [_vm._v("发件人信息")]),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "发件人姓名" } },
                      [
                        _c("el-input", {
                          attrs: { value: _vm.data.sendName, disabled: "" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "手机号码" } },
                      [
                        _c("el-input", {
                          attrs: { value: _vm.data.sendMobile, disabled: "" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "电话号码" } },
                      [
                        _c("el-input", {
                          attrs: { value: _vm.data.sendPhone, disabled: "" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "发件地址" } },
                  [
                    _c("el-input", {
                      attrs: { value: _vm.data.sendCity, disabled: "" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("div", { staticClass: "yto-title" }, [_vm._v("收件人信息")]),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "收件人姓名" } },
                      [
                        _c("el-input", {
                          attrs: {
                            value: _vm.data.postReceiver || "",
                            disabled: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "手机号码" } },
                      [
                        _c("el-input", {
                          attrs: {
                            value: _vm.data.postTel || "",
                            disabled: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "电话号码" } },
                      [
                        _c("el-input", {
                          attrs: {
                            value: _vm.data.receiveMobile || "",
                            disabled: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "收件地址" } },
                  [
                    _c("el-input", {
                      attrs: {
                        value:
                          _vm.data.postProvince ||
                          "" + _vm.data.postCity ||
                          "" + _vm.data.postTown ||
                          "" + _vm.data.postStreet ||
                          "" + _vm.data.postDetail ||
                          "",
                        disabled: "",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "order-detail-yto-box mt20" },
          [
            _c(
              "el-row",
              [
                _c("div", { staticClass: "yto-title" }, [_vm._v("商品信息")]),
                _c(
                  "el-col",
                  {
                    staticClass: "nProductsStyle y-fs-12",
                    attrs: { span: 24 },
                  },
                  [
                    _c("div", { staticStyle: { padding: "20px" } }, [
                      _c("table", { staticClass: "table" }, [
                        _c("thead", [
                          _c("th", [_vm._v("商品名称")]),
                          _c("th", [_vm._v("规格")]),
                          _c("th", [_vm._v("数量")]),
                          _c("th", [_vm._v("单价")]),
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.data.items, function (item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [_vm._v(_vm._s(item.productName))]),
                                _c("td", [_vm._v(_vm._s(item.specifications))]),
                                _c("td", [_vm._v(_vm._s(item.comboNum))]),
                                _c("td", [_vm._v(_vm._s(item.comboAmount))]),
                              ])
                            }),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { colspan: "4" },
                                },
                                [
                                  _c("span", [_vm._v("合计数量：")]),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.data.comboNum) + " 个"),
                                  ]),
                                ]
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "卖家备注" } },
                          [
                            _c("el-input", {
                              attrs: {
                                value: _vm.data.sellerWords,
                                disabled: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "买家留言" } },
                          [
                            _c("el-input", {
                              attrs: {
                                value: _vm.data.buyerWords,
                                disabled: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "order-detail-yto-box mt20" },
          [
            _c(
              "el-row",
              { staticClass: "productTimeInfoSytle y-fs-12" },
              [
                _c(
                  "el-col",
                  [
                    _c("div", { staticClass: "yto-title" }, [
                      _vm._v("时间信息"),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "tit" }, [
                        _vm._v("下单时间："),
                      ]),
                      _c("span", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm.data.createTime)),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "tit" }, [
                        _vm._v("打印快递单时间："),
                      ]),
                      _c("span", { staticClass: "content" }, [
                        _vm._v(
                          _vm._s(
                            _vm.data.waybillPrintTime
                              ? _vm.data.waybillPrintTime
                                  .replace("T", " ")
                                  .substring(0, 19)
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "tit" }, [
                        _vm._v("打印发货单时间："),
                      ]),
                      _c("span", { staticClass: "content" }, [
                        _vm._v(
                          _vm._s(
                            _vm.data.deliverPrintTime
                              ? _vm.data.deliverPrintTime
                                  .replace("T", " ")
                                  .substring(0, 19)
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "tit" }, [
                        _vm._v("订单号码："),
                      ]),
                      _c("span", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm.data.orderId)),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "tit" }, [_vm._v("状态：")]),
                      _c("span", {
                        staticClass: "content",
                        domProps: {
                          textContent: _vm._s(
                            _vm.getOrderStatus(_vm.data.orderStatus)
                          ),
                        },
                      }),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "tit" }, [
                        _vm._v("打印快递单次数："),
                      ]),
                      _c("span", { staticClass: "content" }, [
                        _vm._v(
                          _vm._s(_vm.data.printNum > 0 ? _vm.data.printNum : "")
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "detail-dialog-footer",
          staticStyle: { "margin-top": "20px", "text-align": "center" },
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }